import { Icon, IconSize, IconVariants, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import { useTranslation } from "@next-platform/client-common-core";

import { Row } from "@/components";
import { cn } from "@/utils";

const ModelSelectionHeader = ({ canGoBack, clickHandler, title }: { canGoBack: boolean; clickHandler: () => void; title?: string }) => {
  const { t } = useTranslation();
  return (
    <Row className={cn("items-center px-lg py-md justify-between cursor-pointer hover:bg-gray-7")} onClick={clickHandler}>
      <Row className=" items-center gap-lg">
        {!!canGoBack && <Icon icon={IconVariants.ARROW_LEFT} size={IconSize.MEDIUM} className="text-gray-12" />}
        <Text className="" variant={TextVariants.LABEL_LARGE_REGULAR}>
          {title || t("chat:page.header.modelSelection.dropdown.availableModels.title")}
        </Text>
      </Row>
      {!canGoBack && <Icon icon={IconVariants.CHEVRON_RIGHT} size={IconSize.MEDIUM} className="text-gray-12" />}
    </Row>
  );
};

export default ModelSelectionHeader;
